import { CSS as TableCSS } from '../../components/table/table.style';
import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-Accounts',
	tableCell: 'c-Accounts__TableCell',
	tableCellFaint: 'c-Accounts__TableCell--faint',
	tableCellUppercase: 'c-Accounts__TableCell--uppercase',
	tableCellGhost: 'c-Accounts__TableCell--ghost',
	tableCellRoleActions: 'c-Accounts__TableCellRole',
	changeRole: 'c-Accounts__ChangeRole',
	changeRoleWrapper: 'c-Accounts__ChangeRoleWrapper',
};

export const Style = {
	[CSS.container]: {
		[`& .${TableCSS.container}`]: {
			width: '80%',
			'margin-bottom': DefaultTheme.space(6),
		},
		[`& .${TableCSS.cell}:nth-last-of-type(2)`]: {
			overflow: 'visible',
		},
	},
	[CSS.tableCellFaint]: {
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.tableCellUppercase]: {
		'text-transform': 'uppercase',
	},
	[`${TableCSS.row}:hover .${CSS.tableCellGhost}`]: {
		visibility: 'visible',
	},
	[CSS.tableCellGhost]: {
		visibility: 'hidden',
	},
	[CSS.changeRoleWrapper]: {
		position: 'relative',
		display: 'inline-block',
	},
	[CSS.tableCellRoleActions]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'flex-end',
		'& .mdl-button': {
			'font-size': 'inherit',
		},
	},
};
